import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import MemberOnboardingWizard from './MemberOnboardingWizard';
import { checkFeatureFlag, FEATURE_FLAGS } from '../../../shared/utils/featureFlags';

const MemberOnboardingWrapper = ({ onComplete }) => {
  const { groupId } = useParams();
  const [isFeatureEnabled, setIsFeatureEnabled] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const checkFeature = async () => {
      try {
        setIsLoading(true);
        const enabled = await checkFeatureFlag(FEATURE_FLAGS.MEMBER_ONBOARDING);
        setIsFeatureEnabled(enabled);
      } catch (err) {
        console.error('Error checking member onboarding feature flag:', err);
        setError('Unable to access member onboarding feature');
      } finally {
        setIsLoading(false);
      }
    };

    checkFeature();
  }, []);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen px-4">
        <div className="text-center">
          <div className="w-16 h-16 bg-error-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-error-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h2 className="text-lg font-semibold text-neutral-900 mb-2">Feature Not Available</h2>
          <p className="text-neutral-600">{error}</p>
        </div>
      </div>
    );
  }

  if (!isFeatureEnabled) {
    return (
      <div className="flex items-center justify-center min-h-screen px-4">
        <div className="text-center">
          <div className="w-16 h-16 bg-neutral-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-neutral-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h2 className="text-lg font-semibold text-neutral-900 mb-2">Member Onboarding Disabled</h2>
          <p className="text-neutral-600">The member onboarding feature is currently disabled.</p>
        </div>
      </div>
    );
  }

  return <MemberOnboardingWizard groupId={groupId} onComplete={onComplete} />;
};

export default MemberOnboardingWrapper;
